var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"pdf-preview",class:_vm.$env.VUE_APP_DESIGNER && _vm.$style.room,staticStyle:{"display":"flex","flex-direction":"column"},attrs:{"id":"pdf-preview"}})}
var staticRenderFns = []

export { render, staticRenderFns }